import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { Product } from "src/app/api/models";
import { RetrieveService } from "src/app/api/services";
import { ProductService } from "src/app/shared/services/product.service";

export interface SearchParams {
  category?: number
  origin?: string,
  quantityFrom?: number,
  limit?: number;
  offset?: number;
  sort?: 'modified_at' | 'price' | 'created_at';
  order?: 'asc' | 'desc' ;
}


export interface SortOption {
  display: string,
  sort: 'modified_at' | 'price' | 'created_at',
  order: 'asc' | 'desc',
}


@Component({
  selector: "app-product-list",
  templateUrl: "./product-list.component.html",
  styleUrls: ["./product-list.component.scss"],
})
export class ProductListComponent implements OnInit, AfterViewInit {
  productList: Product[];
  loading = false;
  origins$: Observable<string[]>

  defaultCategory = 1
  searchParams: SearchParams = {
    category: this.defaultCategory,
    quantityFrom: 1
  };

  sortingOptions: SortOption[]  = [
    {
      'display': 'Prima le novità',
      'sort': 'modified_at',
      'order': 'desc'
    },
    {
      'display': 'Offerta minima crescente',
      'sort': 'price',
      'order': 'asc'
    },
    {
      'display': 'Offerta minima decrescente',
      'sort': 'price',
      'order': 'desc'
    }
  ]


  /** Filters */
  originForm = new FormGroup({
    origin: new FormControl(),
  });

  sortForm = new FormGroup({
    sortOption: new FormControl()
  });
 

  /* Pagination */
  defaultPageSize = 15;
  pageIndex: number;
  pageSize: number;

  pageIndexSub= new Subject<number>();

  total: number;

  constructor(
    // public authService: AuthService,
    private retrieveService: RetrieveService,
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
  ) {}

  ngOnInit() {
    this.origins$ = this.retrieveService.getOrigins({minQuantity: 1})

    /* Read query parameters from URL */
    this.route.queryParams.subscribe(params => {
      this.originForm.controls.origin.setValue(params['origin'], { emitEvent: false });
      this.pageIndex = Number(params['pageIndex']) || 0;
      this.pageSize = Number(params['pageSize']) || this.defaultPageSize;
      this.sortForm.controls.sortOption.setValue(this.getSortOption(params['sort'], params['order']) ? this.getSortOption(params['sort'], params['order']): this.sortingOptions[0]);
      this.loadProducts();
    });
  }

  ngAfterViewInit() {

    this.originForm.get('origin').valueChanges.pipe(
      ).subscribe(value => {
        this.router.navigate(['products/all-products'], {
          queryParams: {
            origin: value,
            pageIndex: 0
          },
          queryParamsHandling: 'merge'
        });
      });

    this.sortForm.get('sortOption').valueChanges.pipe(
      ).subscribe((value) => {
        if (value == undefined){
          value = this.sortingOptions[0];       
        }
        this.router.navigate(['products/all-products'], {
          queryParams: {
            sort: value.sort,
            order: value.order,
          },
          queryParamsHandling: 'merge'
        });
      });


    this.pageIndexSub.pipe(
      ).subscribe(value => {
        this.router.navigate(['products/all-products'], {
          queryParams: {
            pageIndex: value
          },
          queryParamsHandling: 'merge'
        });
      });

  }


  getSortOption(sort: string, order: string): SortOption {
    let selected: SortOption
    this.sortingOptions.forEach((option) =>{
      if(option.sort == sort && option.order == order){
        selected = option
      }
    })
    return selected
  }

  changeSort(sortOption: SortOption) {
    this.router.navigate(['products/all-products'], {
      queryParams: {
        sort: sortOption.sort,
        order: sortOption.order,
      },
      queryParamsHandling: 'merge'
    });
  }

  loadProducts(): void {
    /**
     * Load a page of products based on current parameters
     */

    /* Pagination */
    this.searchParams['offset'] = Math.max(0, (this.pageIndex - 1) * this.pageSize);
    this.searchParams['limit'] = this.pageSize;

    /* Filters */
    this.searchParams['origin'] = this.originForm.get('origin').value;

    this.searchParams['sort'] = this.sortForm.get('sortOption').value ? this.sortForm.get('sortOption').value.sort : 'modified_at';
    this.searchParams['order'] = this.sortForm.get('sortOption').value ? this.sortForm.get('sortOption').value.order : 'desc';

    this.getAllProducts(this.searchParams);
  
  }
  
  getAllProducts(searchParams: SearchParams) {
    this.loading = true;
    const x = this.retrieveService.getProducts(searchParams);
    x.subscribe(
      (product) => {
        this.loading = false;
        this.productList = [];
        product.forEach((element) => {
          this.productList.push(element as Product);
        });
      },
      (err) => {
      }
    );

    const count = this.retrieveService.countProducts(searchParams);
    count.subscribe(
      (count) => {
        this.total = count;
      },
      (err) => {
      }
    );
  }

  getPage(page: number) {
    this.pageIndexSub.next(page);
  }


  addToCart(product: Product) {
    this.productService.addToCart(product);
  }
}
